// ---------------------------------------------------------------------------
// AppLock — Lock state machine
// ---------------------------------------------------------------------------
/**
 * Valid transitions expressed as `from → to[]`.
 * Any transition not listed here is rejected.
 */
const VALID_TRANSITIONS = {
    uninitialized: ['locked'],
    locked: ['unlocking', 'uninitialized'],
    unlocking: ['unlocked', 'locked', 'error'],
    unlocked: ['locked', 'uninitialized'],
    error: ['locked', 'uninitialized'],
};
export class StateMachine {
    constructor(bus) {
        this.bus = bus;
        this._state = 'uninitialized';
        this._lockReason = 'init';
    }
    /** Current state. */
    get state() {
        return this._state;
    }
    /** Why the app was last locked. */
    get lockReason() {
        return this._lockReason;
    }
    /** Whether the app is in a locked or unlocking state. */
    get isLocked() {
        return this._state === 'locked' || this._state === 'unlocking';
    }
    /** Whether a password has been configured. */
    get isConfigured() {
        return this._state !== 'uninitialized';
    }
    /**
     * Attempt a state transition.
     * Throws if the transition is invalid.
     */
    transition(to, reason) {
        const from = this._state;
        if (!VALID_TRANSITIONS[from]?.includes(to)) {
            throw new Error(`[AppLock] Invalid state transition: "${from}" → "${to}"`);
        }
        this._state = to;
        if (to === 'locked' && reason) {
            this._lockReason = reason;
        }
        this.bus.emit('state:change', { from, to });
    }
    /**
     * Force state without validation.
     * Used only during initialization to restore persisted state.
     */
    forceState(state) {
        this._state = state;
    }
}
//# sourceMappingURL=state-machine.js.map